interface MobileNavProps {
  isScrolled: boolean;
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
  onBookingClick: () => void;
}

export default function MobileNav({ 
  isScrolled, 
  isMobileMenuOpen, 
  setIsMobileMenuOpen,
  onBookingClick 
}: MobileNavProps) {
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      {/* Sticky Mobile Navigation */}
      <nav 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between px-4 sm:px-6 py-4">
          <div className={`text-xl sm:text-2xl font-bold transition-colors ${
            isScrolled ? 'text-gray-900' : 'text-white'
          }`}>
            Floorvana Flooring
          </div>
          
          <div className="flex items-center gap-3">
            <button
              onClick={onBookingClick}
              className="bg-amber-600 hover:bg-amber-700 text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Book a Call
            </button>
            
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-gray-900 hover:bg-gray-100' 
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="Toggle menu"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* Mobile Menu Drawer */}
      <div 
        className={`fixed top-0 right-0 bottom-0 w-72 sm:w-80 bg-white z-50 shadow-2xl transform transition-transform duration-300 ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
            <h3 className="text-xl font-bold text-gray-900">Menu</h3>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-10 h-10 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              aria-label="Close menu"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto py-6">
            <ul className="space-y-1 px-4">
              {[
                { label: 'Services', id: 'services', icon: 'ri-service-line' },
                { label: 'Projects', id: 'projects', icon: 'ri-gallery-line' },
                { label: 'About', id: 'about', icon: 'ri-information-line' },
                { label: 'Testimonials', id: 'testimonials', icon: 'ri-chat-quote-line' }
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="w-full flex items-center gap-3 px-4 py-3.5 text-left text-gray-700 hover:bg-gray-50 hover:text-amber-600 rounded-lg transition-all cursor-pointer group"
                  >
                    <i className={`${item.icon} text-xl text-gray-400 group-hover:text-amber-600 transition-colors`}></i>
                    <span className="font-medium">{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className="border-t border-gray-200 p-6 space-y-3">
            <a
              href="tel:+16476860280"
              className="w-full flex items-center justify-center gap-2 bg-gray-900 text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-gray-800 transition-all cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Call Now
            </a>
            <button
              onClick={() => {
                onBookingClick();
                setIsMobileMenuOpen(false);
              }}
              className="w-full bg-amber-600 text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-amber-700 transition-all cursor-pointer"
            >
              Book Free Estimate
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
